import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AvailabilityGate } from './service/AvailabilityGate';
import { ErrorBoundary } from './ui/ErrorBoundary';
import './styles/app.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('#root element is missing from index.html');
}

// StrictMode double-invokes effects in development, which is exactly the
// stress test PhaserHost must survive without recreating the canvas twice.
//
// Two boundaries, in this order. `AvailabilityGate` asks the server whether it
// is serving at all and mounts nothing until it answers; `AuthGate`, inside it,
// is the session boundary, so the game and Phaser only exist under a confirmed
// session of a service that is running.
createRoot(rootElement).render(
  <StrictMode>
    {/*
      Outside both gates, so it catches them too. A render error anywhere below
      this leaves a message on the screen instead of the page's background
      colour, which is what an unmounted tree looks like: black, and silent.
    */}
    <ErrorBoundary>
      <AvailabilityGate />
    </ErrorBoundary>
  </StrictMode>,
);
